import cn from "classnames"
import React from "react"
import { getDistinct, useSelector } from "swiipe.portal.shared"
import { calculateTranslationValue } from "../../../services/translationService"
import { translationSelectors } from "../../../store/reducers/translationSlice"
import { ITranslationItem } from "../../../type/translations/ITranslationItem"
import "./TranslationMissingBadge.scss"

interface ITranslationMissingBadgeProps {
    items: ITranslationItem[]
    className?: string
}

interface IMissingTranslation {
    itemId: string
    language: string
}

const TranslationMissingBadge = ({ items, className }: ITranslationMissingBadgeProps) => {
    const changes = useSelector(translationSelectors.changes)
    const currentLanguage = useSelector(translationSelectors.currentLanguage)
    const languageConfigs = useSelector(translationSelectors.languageConfigs) ?? []
    const showMissingTranslationCounters = useSelector(translationSelectors.showMissingTranslationCounters)
    if (!showMissingTranslationCounters) {
        return null
    }

    const shortLanguage = languageConfigs?.find((l) => l.language === currentLanguage)?.shortCulture ?? currentLanguage
    const relevantChanges = changes.filter((c) => items.some((i) => i.id === c.itemId))
    const missing = items.reduce((missing, item) => {
        const missingLanguagesForItem = languageConfigs.filter(
            (lc) => !calculateTranslationValue(item, relevantChanges, lc.language)
        )
        missing.push(...missingLanguagesForItem.map<IMissingTranslation>((lc) => ({ itemId: item.id, language: lc.language })))
        return missing
    }, [] as IMissingTranslation[])

    const numMissing = missing.length
    if (numMissing === 0) {
        return null
    }

    return (
        <div className={cn("translation-missing-badge", className)}>
            <div className={cn("translation-missing-badge__container")}>
                <div className={cn("translation-missing-badge__language")}>
                    {shortLanguage}: {missing.filter((m) => m.language === currentLanguage).length}
                </div>
                <div className={cn("translation-missing-badge__divider")}></div>
                <div className={cn("translation-missing-badge__type")}>types: {getDistinct(missing, (m) => m.itemId).length}</div>
                <div className={cn("translation-missing-badge__divider")}></div>
                <div className={cn("translation-missing-badge__all")}>all: {missing.length}</div>
            </div>
        </div>
    )
}

export default React.memo(TranslationMissingBadge)
